import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue";
var _hoisted_1 = {
  class: "todo-container"
};
var _hoisted_2 = {
  class: "todo-top"
};
var _hoisted_3 = {
  class: "left-box"
};
var _hoisted_4 = {
  key: 0,
  class: "empty"
};
var _hoisted_5 = {
  key: 0,
  class: "todo-content"
};
import dayjs from 'dayjs';
import { validateNull } from '@/util/validate';
import { MessagePlugin } from 'tdesign-vue-next';
import { getStore } from '@/util/store.js';
import { appAliasEvent } from '@/utils/auth.js';
import { getSelect } from '@/api/todo';
import { getPlanData } from '@/api/home.js';
import { skipUrl as skipUrlOpen } from '@/util/util';
import TodoItem from './TodoItem';
import { onMounted, computed, ref } from 'vue';
export default {
  __name: 'TodoList',
  props: {
    single: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var accessToken = getStore({
      name: 'access_token'
    }); // 获取accessToken
    // 获取前缀的值
    var getBytesText = function getBytesText(textType) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var colors = ['#1E72FC', '#0CB078', '#07B8B8', '#F09322'];
      var days = [null, '日', '周', '月'];
      var color = colors[textType - 1];
      var colorText = textType === 4 ? '批' : days[type];
      return {
        colorText: colorText,
        color: color
      };
    };
    var todoData = ref([]);
    var loading = ref(true);
    onMounted(function () {
      initData();
    });
    var isEmpty = computed(function () {
      return !loading.value && validateNull(todoData.value);
    });
    /**
     * 初始化数据
     */
    var initData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var result, data, homeAgentVos, list, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              loading.value = true;
              todoData.value = [];
              _context.p = 1;
              _context.n = 2;
              return getPlanData('teacher');
            case 2:
              result = _context.v;
              data = result.data.data;
              homeAgentVos = data.homeAgentVos;
              if (!(validateNull(data) || validateNull(homeAgentVos))) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              list = props.single ? [homeAgentVos[0]] : homeAgentVos.splice(0, 2);
              todoData.value = list.map(function (item) {
                return initTodoData(item);
              });
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              (_t === null || _t === void 0 ? void 0 : _t.message) && MessagePlugin.warning(_t === null || _t === void 0 ? void 0 : _t.message);
            case 5:
              _context.p = 5;
              loading.value = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, null, [[1, 4, 5, 6]]);
      }));
      return function initData() {
        return _ref.apply(this, arguments);
      };
    }();
    /**
     * 初始化待办事项数据
     * @param activeItem
     */
    var initTodoData = function initTodoData(activeItem) {
      var startTime = activeItem.startTime,
        endTime = activeItem.endTime,
        backlogType = activeItem.backlogType,
        type = activeItem.type;
      var _getBytesText = getBytesText(backlogType, type),
        colorText = _getBytesText.colorText,
        color = _getBytesText.color;
      var isOverdue = dayjs().valueOf() > Number(endTime);
      return _objectSpread(_objectSpread({}, activeItem), {}, {
        range: "".concat(dayjs(Number(startTime)).format('HH:mm'), "-").concat(dayjs(Number(endTime)).format('HH:mm')),
        isChecked: false,
        isOverdue: isOverdue,
        colorText: colorText,
        color: color
      });
    };
    /**
     * 新增待办事项
     */
    var addTodo = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var appUrl, url;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return appAliasEvent('todoList');
            case 1:
              appUrl = _context2.v;
              if (appUrl) {
                url = "".concat(appUrl, "?todoList=/edit&token=").concat(accessToken);
                skipUrlOpen(url);
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function addTodo() {
        return _ref2.apply(this, arguments);
      };
    }();
    /**
     * 打开日程和待办
     */
    var goTodoApp = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var appUrl, url;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return appAliasEvent('todoList');
            case 1:
              appUrl = _context3.v;
              if (appUrl) {
                url = "".concat(appUrl, "?token=").concat(accessToken);
                skipUrlOpen(url);
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function goTodoApp() {
        return _ref3.apply(this, arguments);
      };
    }();
    /**
     * 跳转详情
     * @param item 待办事项
     */
    var goTodoDetaill = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(item) {
        var appUrl, url;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return appAliasEvent('todoList');
            case 1:
              appUrl = _context4.v;
              if (appUrl) {
                url = "".concat(appUrl, "?todoList=%2Ftodo/").concat(item.id, "/").concat(item.backlogType, "&token=").concat(accessToken);
                skipUrlOpen(url);
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function goTodoDetaill(_x) {
        return _ref4.apply(this, arguments);
      };
    }();
    // 点击复选框的时候触发
    var handleClick = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(val) {
        var _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return getSelect(_objectSpread({}, val));
            case 1:
              initData();
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t2 = _context5.v;
              (_t2 === null || _t2 === void 0 ? void 0 : _t2.message) && MessagePlugin.warning(_t2 === null || _t2 === void 0 ? void 0 : _t2.message);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, null, [[0, 2]]);
      }));
      return function handleClick(_x2) {
        return _ref5.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _component_Loading = _resolveComponent("Loading");
      var _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [loading.value ? (_openBlock(), _createBlock(_component_Loading, {
        key: 0,
        class: "z-center"
      })) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "title"
      }, "待办", -1)), _createElementVNode("div", {
        class: "icon-box",
        onClick: addTodo
      }, [_createVNode(_component_svg_icon, {
        name: "add-circle"
      })])]), _createElementVNode("div", {
        class: "icon-box",
        onClick: goTodoApp
      }, [isEmpty.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, "暂无待办")) : _createCommentVNode("", true), _createVNode(_component_svg_icon, {
        name: "arrow-right-not"
      })])]), !isEmpty.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(todoData.value, function (item) {
        return _openBlock(), _createBlock(_unref(TodoItem), {
          key: item.id,
          item: item,
          onChange: goTodoDetaill,
          onCheck: handleClick
        }, null, 8, ["item"]);
      }), 128))])) : _createCommentVNode("", true)], 64))]);
    };
  }
};